import { AuthUser } from "@/lib/Auth/authApi";

/** Only the name is required — phone and date of birth stay optional. */
export function isProfileComplete(
  user: Pick<AuthUser, "name"> | null,
): boolean {
  if (!user) {
    return true;
  }

  return !!user.name?.trim();
}
